/**
 * Utility functions for formatting currency values
 */

/**
 * Format a number as currency with KES suffix
 * @param {number} value - The numeric value to format
 * @param {boolean} includeCurrency - Whether to include "KES" suffix (default: true)
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (value, includeCurrency = true) => {
  const formatted = Number(value || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  
  return includeCurrency ? `${formatted} KES` : formatted;
};

/**
 * Format a number as currency without suffix (for display in large cards)
 * @param {number} value - The numeric value to format
 * @returns {string} Formatted number string without currency suffix
 */
export const formatAmount = (value) => {
  return formatCurrency(value, false);
};
